import api from './api';
import { requestPushPermission } from '../serviceWorker';

class PushNotificationService {
  async registerPushSubscription(userId) {
    try {
      // Solicitar permissão e obter subscription
      const subscription = await requestPushPermission();
      
      if (!subscription) {
        console.log('Não foi possível obter push subscription');
        return null;
      }

      // Converter subscription para formato que pode ser enviado ao servidor
      const subscriptionData = {
        endpoint: subscription.endpoint,
        keys: {
          p256dh: this.arrayBufferToBase64(subscription.getKey('p256dh')),
          auth: this.arrayBufferToBase64(subscription.getKey('auth'))
        },
        userAgent: navigator.userAgent,
        device: this.getDeviceInfo()
      };

      // Enviar subscription para o backend
      const response = await api.post('/push-subscriptions', {
        userId,
        ...subscriptionData
      });

      console.log('Push subscription registrada com sucesso:', response.data);
      return response.data;
    } catch (error) {
      console.error('Erro ao registrar push subscription:', error);
      throw error;
    }
  }

  async unregisterPushSubscription(subscriptionId) {
    try {
      await api.delete(`/push-subscriptions/${subscriptionId}`);
      console.log('Push subscription removida com sucesso');
    } catch (error) {
      console.error('Erro ao remover push subscription:', error);
      throw error;
    }
  }

  async getPushSubscriptions(userId) {
    try {
      const response = await api.get(`/push-subscriptions?userId=${userId}`);
      return response.data;
    } catch (error) {
      console.error('Erro ao buscar push subscriptions:', error);
      throw error;
    }
  }

  // Converter ArrayBuffer para Base64
  arrayBufferToBase64(buffer) {
    const bytes = new Uint8Array(buffer);
    let binary = '';
    for (let i = 0; i < bytes.byteLength; i++) {
      binary += String.fromCharCode(bytes[i]);
    }
    return window.btoa(binary);
  }

  // Obter informações do dispositivo
  getDeviceInfo() {
    const ua = navigator.userAgent;
    if (/android/i.test(ua)) {
      return 'Android';
    } else if (/iPad|iPhone|iPod/.test(ua)) {
      return 'iOS';
    } else if (/Windows/.test(ua)) {
      return 'Windows';
    } else if (/Mac/.test(ua)) {
      return 'macOS';
    } else if (/Linux/.test(ua)) {
      return 'Linux';
    }
    return 'Unknown';
  }

  // Verificar se push notifications estão disponíveis
  isPushSupported() {
    return (
      'serviceWorker' in navigator &&
      'PushManager' in window &&
      'Notification' in window
    );
  }

  // Verificar permissão atual
  async getPermissionStatus() {
    if (!('Notification' in window)) {
      return 'not-supported';
    }
    return Notification.permission;
  }
}

export default new PushNotificationService();

